import { createFileRoute } from '@tanstack/react-router';
import { SecuritySettings } from '@/pet/src/components/shared/SecuritySettings';

export const Route = createFileRoute('/dashboard/settings/security')({
  component: SecurityPage,
});

function SecurityPage() {
  // Get owner details from localStorage
  const stored = localStorage.getItem('petso_owner_details');
  let ownerDetails = { name: '', email: '' };
  
  if (stored) {
    try {
      ownerDetails = JSON.parse(stored);
    } catch (e) {
      console.error('Failed to parse owner details:', e);
    }
  }

  return (
    <SecuritySettings 
      userEmail={ownerDetails.email}
      userName={ownerDetails.name}
      platform="petso"
    />
  );
}
